import { biLoggerFactory } from 'wix-private'
import wixWindow from 'wix-window'

const SRC = 19
const END_POINT = 'hp'
const BI_EVENTS = {
    headerAction: 349
}

/**
 * Sends a custom BI event by event name as defined in the config.json 
 * @function sendBI
 * @param {string} eventName - The name of the event you defined in the config.json.
 * @param {object} params - Additional required BI params.
 * @example
 * sendBI("editAppClick", {isUserCool: true, veryCool: false})
 * @returns {Promise<object>} platformBiLogger results object
 */
let platformBiLogger = null
export const sendBi = async (eventName, params = {}) => {
    if (wixWindow.rendering.env !== 'browser') return

    if (!platformBiLogger) {
        platformBiLogger = await biLoggerFactory(END_POINT, SRC, {})
    }

    const evid = BI_EVENTS[eventName]

    // console.log('BI', END_POINT, SRC, evid, params)
    return platformBiLogger.log({ ...params, evid })
}

/**
 * Sends a custom BI event by src,endpoint and event ID. 
 * @function sendBI
 * @param {number} src - src number.
 * @param {string} endpoint - endpoint.
 * @param {number} evid - evid number.
 * @param {object} params - Additional required BI params.
 * @example
 * sendCustomBI(19, "lp", 204, {isUserCool: true, veryCool: false})
 * @returns {Promise<object>} platformBiLogger results object
 */
export const sendCustomBI = async (src, endpoint, evid, params = {}) => {
    if (wixWindow.rendering.env !== 'browser') return

    if (!endpoint || !src || !params) {
        throw 'Invalid event, missing required parameters'
    }

    const platformBiLogger = await biLoggerFactory(endpoint, src, {})

    // console.log('BI', endpoint, src, params.evid, params)
    return platformBiLogger.log({ ...params, evid })
}